module.exports = __webpack_public_path__ + "img/bg.8cf2084d.png";